import styled from "styled-components";


export const Container = styled.div`

    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 600;
    width: 200px;
    outline: 0;

    border: 3px solid black;
    border-radius: 10px;

    background-color: white;
    
`;

export const Header = styled.div`

    height: 80px;

    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    padding-left: 5px;

    border-bottom: 2px solid black;


`;

export const TitleHeader = styled.h1`

    margin-left: 7px;

`;

export const CloseButtonHeader = styled.div`

    border: none;
    border-radius: 3px;
    margin-left: 0.5rem;
    margin-right: 5px;
    background: none;
    :hover {
        cursor: pointer;
    }

`;

export const Content = styled.div`

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    margin-bottom: 20px;

`;